import 'echarts/lib/chart/line';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import { merge } from 'lodash';

import ChartService from './ChartService';
import { generateColors, splitSentanceToWords, splitWordsToLines, trimDotEnd, isTextWithinLimit } from './chartCommon';

export default class ChartHorizontalGroupBarService extends ChartService {
  buildChartData(visualization, isEditMode) {
    const colors = visualization.data.length ? generateColors(visualization.data[0].children.length) : [];

    const options = {
      grid: {
        bottom: '2%',
        containLabel: true,
        left: '10px',
        right: '5%',
        top: '10%'
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        },
        formatter(params) {

          if (visualization.formatter) {
            return visualization.formatter(params.map((param) => ({
              ...param,
              dataIndex: visualization.data.length - 1 - param.dataIndex
            })));
          }
        }
      },
      toolbox: {
        show: true,
        orient: 'vertical',
        left: 'right',
        top: 'center',
        feature: {
          mark: { show: true },
          dataView: { show: true, readOnly: false },
          magicType: { show: true, type: ['line', 'bar', 'stack', 'tiled'] },
          restore: { show: true },
          saveAsImage: { show: true }
        }
      },
      yAxis: {
        axisLabel: {
          color: '#000',
          formatter: (value) => {
            const splitted = splitWordsToLines(splitSentanceToWords(value).map((word) => ({ word })), isTextWithinLimit(253), 2);
            if (splitted[2]) {
              splitted[2] = trimDotEnd(splitted[2], isTextWithinLimit(253));
            }

            return splitted.map((f) => f.sentance).join('\n');
          },
          fontSize: 11,
        },
        axisLine: {
          lineStyle: {
            color: '#767676',
          },
        },
        axisTick: {
          alignWithLabel: true,
          lineStyle: {
            color: '#767676',
          }
        },
        data: visualization.data.map((f) => f[visualization.name_field]).reverse()
      },
      xAxis: {
        axisLabel: {
          fontSize: 13,
          rotate: 0,
        },
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        name: visualization.value_field,
        nameLocation: 'center',
        nameGap: 75,
        nameTextStyle: {
          fontWeight: 'bold',
          fontSize: 13,
        },
      },
      series: visualization.data.length ? visualization.data[0].children.map((ch, ind) => ({
        name: ch[visualization.name_field],
        type: 'bar',
        barGap: 0,
        barCategoryGap: '5',

        barMaxWidth: 40,
        itemStyle: {
          barBorderRadius: [0, 4, 4, 0],
          opacity: 0.8,
        },

        data: visualization.data.map((item, index) => {
          const defaultColor = item.children[ind]['color'] || colors[ind];
          const uncheckedColor = 'rgb(216,216,216)';

          const color = isEditMode && item.unchecked ? uncheckedColor : defaultColor;

          return {
            data: item,
            dataIndex: index,
            value: item.children[ind][visualization.value_field],
            defaultColor,
            itemStyle: {
              normal: { color },
              emphasis: { color, opacity: 1 }
            }
          };
        }).reverse()
      })) : [],
    };

    return merge(this.defaultChartOptions, options);
  }
}
